import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useNavContext } from "../../context/nav_context";
import {
  register_ok_title,
  register_ok_description_part_01,
  register_ok_description_part_02,
} from "../../utils/texts";
import {
  api_v3_user_detail_update,
  api_v3_list_of_clans,
  api_v3_get_tournament_by_id,
  discordUrl,
  current_background_video,
} from "../../utils/constants";

const RegisterTournamentOk = ({ tournamentId }) => {
  const { user, accessToken, refreshUser } = useNavContext();
  const [userInfo, setUserInfo] = useState(user);
  const [tournamentInfo, setTournamentInfo] = useState(null);
  const [aoe2ProfileId, setAoe2ProfileId] = useState();
  const [dataComplete, setDataComplete] = useState(false);

  // Clan selection
  const [clans, setClans] = useState([]);
  const [clansInProgress, setClansInProgress] = useState(false);
  const [clansError, setClansError] = useState(false);
  const [showClanSelector, setShowClanSelector] = useState(false);
  const [selectedClanId, setSelectedClanId] = useState(-1);
  const [clanImage, setClanImage] = useState("");
  const [clanId, setClanId] = useState(-1);
  const [clanName, setClanName] = useState("");

  useEffect(() => {
    const loadTournamentInfo = async () => {
      try {
        const response = await axios.get(
          api_v3_get_tournament_by_id(tournamentId)
        );
        if (response.status === 200) {
          setTournamentInfo(response.data);
        }
      } catch (error) {
        console.error("Error loading tournament info:", error);
      }
    };
    loadTournamentInfo();

    const loadClans = async () => {
      try {
        setClansInProgress(true);
        setClansError(false);
        const response = await axios.get(api_v3_list_of_clans());
        if (response.status === 200) {
          const clans_list = response.data.sort((a, b) =>
            a.name > b.name ? 1 : -1
          );
          setClans(clans_list);
          setClansInProgress(false);
          setClansError(false);
          return true;
        } else {
          console.log(`(${response.status}) response: ${response.data}`);
          setClansInProgress(false);
          setClansError(true);
          return false;
        }
      } catch (error) {
        setClansInProgress(false);
        setClansError(true);
        return false;
      }
    };
    loadClans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (userInfo) {
      if (userInfo.aoe2ProfileId) {
        setAoe2ProfileId(userInfo.aoe2ProfileId);
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (clans && clans.length > 0) {
      var clan_identifier = userInfo && userInfo.clanId ? userInfo.clanId : -1;
      var clan_filtered = clans.filter(
        (clan) => clan.clanId === clan_identifier
      );
      console.log(`1clan_filtered: ${JSON.stringify(clan_filtered)}`);
      if (!clan_filtered || clan_filtered.length === 0) {
        clan_filtered = clans.filter((clan) => clan.name === "<No tengo clan>");
      }
      console.log(`2clan_filtered: ${JSON.stringify(clan_filtered)}`);

      setClanImage(clan_filtered[0].image);
      setClanName(clan_filtered[0].name);
      setClanId(clan_filtered[0].clanId);
      setSelectedClanId(clan_filtered[0].clanId);
    }
  }, [userInfo, clans]);

  const saveClan = async () => {
    console.log(
      `saveClan :: close clan selector. Selected clanId: ${selectedClanId}`
    ); // DEBUG
    const clan_filtered = clans.filter(
      (clan) => clan.clanId === selectedClanId
    )[0];

    console.log(
      `saveClan :: Selected clan: id=${clan_filtered.clanId} | name=${clan_filtered.name} | image=${clan_filtered.image}`
    ); // DEBUG
    setClanImage(clan_filtered.image);
    setClanName(clan_filtered.name);
    setClanId(clan_filtered.clanId);

    var access_token = accessToken || localStorage.getItem("access_token");
    if (!access_token) {
      console.error(`saveClan :: saveUsername -> it's necessary be loged`);
      return false;
    }
    const config = {
      headers: { Authorization: `Bearer ${access_token}` },
    };
    var data = { ...userInfo, clanId: selectedClanId };

    console.log(
      `saveClan :: Updating clan: ${JSON.stringify(
        data
      )} -> url:${api_v3_user_detail_update()}`
    );
    const response = await axios.post(
      api_v3_user_detail_update(),
      data,
      config
    );

    if (response.status === 201) {
      console.log(
        `saveClan :: Call to PUT /user return 201 status: ${JSON.stringify(
          response.data
        )}`
      );

      setUserInfo({ ...userInfo, clanId: selectedClanId });
      await refreshUser();
    } else {
      console.log(
        `saveClan :: Call to PUT /user return wrong status: ${
          response.status
        } -> ${JSON.stringify(response.data)}`
      );
    }

    setShowClanSelector(false);
  };

  const saveUserData = async () => {
    var access_token = accessToken || localStorage.getItem("access_token");
    if (!access_token) {
      console.error(`saveUserData -> it's necessary be loged`);
      return false;
    }
    const config = {
      headers: { Authorization: `Bearer ${access_token}` },
    };
    var data = {
      ...userInfo,
      aoe2ProfileId: aoe2ProfileId,
      clanId: clanId,
    };
    const response = await axios.post(
      api_v3_user_detail_update(),
      data,
      config
    );

    if (response.status === 200) {
      await refreshUser();
      setUserInfo({
        ...userInfo,
        aoe2ProfileId: aoe2ProfileId,
        clanId: clanId,
      });
      setDataComplete(true);
    }
  };

  if (showClanSelector) {
    if (clansInProgress) {
      return (
        <Wrapper>
          <ClanSelector>
            <div className="loading">
              <div className="lds-dual-ring"></div>
            </div>
          </ClanSelector>
        </Wrapper>
      );
    }

    if (clansError) {
      return (
        <Wrapper>
          <ClanSelector>
            <h2>Error al cargar los clanes</h2>
            <p>
              Por favor, intenta más tarde o contacta con nosotros para
              solucionarlo.
            </p>
          </ClanSelector>
        </Wrapper>
      );
    }

    return (
      <Wrapper>
        <ClanSelector>
          <h2>Selecciona un clan</h2>
          <div className="row-clan-selector">
            {clans.map((clan) => {
              return (
                <div
                  className={`clan-icon ${
                    clan.clanId === selectedClanId ? "clan-selected" : ""
                  }`}
                  key={`clan-icon-${clan.clanId}-${clanId}`}
                  onClick={() => setSelectedClanId(clan.clanId)}
                >
                  <img src={clan.image} alt={clan.name} />
                  <span>{clan.name}</span>
                </div>
              );
            })}
          </div>
          <button className="btn" onClick={saveClan}>
            Guardar cambios
          </button>
        </ClanSelector>
      </Wrapper>
    );
  }

  if (!userInfo) {
    return (
      <Wrapper>
        <div className="container">
          <video
            className="background-video"
            src={current_background_video}
            muted
            autoPlay
            preload="auto"
            loop
            type="video/mp4"
          ></video>
        </div>
        <Content>
          <div className="info">
            <h2>REGISTRADO, PERO...</h2>
            <Link to={`/register/tournament/${tournamentId}`}>
              <button className="btn space-around">Reintentar registro</button>
            </Link>
            <p className="more-help">
              <i>
                Estás registrado en el torneo, pero es posible que nos falte
                algún dato ya que hemos tenido un problema validando tus datos.
                En los próximos días la organización revisará tus datos y si
                falta algo nos pondremos en contacto contigo. Si no te decimos
                nada, todo está bien.
              </i>
            </p>
          </div>
        </Content>
      </Wrapper>
    );
  }
  if (!dataComplete) {
    return (
      <Wrapper>
        <div className="container">
          <video
            className="background-video"
            src={current_background_video}
            muted
            autoPlay
            preload="auto"
            loop
            type="video/mp4"
          ></video>
        </div>

        <Content>
          <div className="info">
            <h2>Revisa tus datos:</h2>
            <p>Necesitamos que nos proporciones tu id de AoE2:</p>
            <input
              className="input-text-field-small"
              type="text"
              placeholder="AoE2 ProfileId"
              value={aoe2ProfileId || ""}
              name="aoe2 ProfileId"
              onChange={(event) => {
                const value = event.target.value;
                // La expresión regular /^$|^\d+$/ permite una cadena vacía o una cadena numérica
                if (/^$|^\d+$/.test(value)) {
                  setAoe2ProfileId(value);
                }
              }}
            />
            <p className="more-help">
              ¿No sabes como hacerlo? Es muy sencillo. Ve a{" "}
              <a
                href="https://www.aoe2insights.com/"
                target="_blank"
                rel="noreferrer"
              >
                aoe2insights.com
              </a>
              , busca tu perfil y copia el numero que aparece en la url (algo
              como esto: https://www.aoe2insights.com/user/
              <span style={{ color: "var(--clr-yellow-dark)" }}>6956546</span>/)
            </p>
            <p className="more-help">
              Es <u>muy importante</u> que te unas también al{" "}
              <a href={discordUrl} target="_blank" rel="noreferrer">
                canal de discord de la Comunidad Española
              </a>
              . Haz click en el icono para unirte:
            </p>
            <img
              className="rrss"
              src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/discord_color.jpg"
              alt="discord"
              onClick={() => window.open(discordUrl, "_blank")}
            />
            <Warning>
              <h2>
                Requisito OBLIGATORIO para inscribirse en la{" "}
                {tournamentInfo?.name}
              </h2>
              El periodo de inscripciones es del{" "}
              {
                tournamentInfo?.periods
                  .find((p) => p.name === "Inscripciones")
                  ?.startDate.split("T")[0]
              }{" "}
              hasta el{" "}
              {
                tournamentInfo?.periods
                  .find((p) => p.name === "Inscripciones")
                  ?.endDate.split("T")[0]
              }{" "}
              a las{" "}
              {tournamentInfo?.periods
                .find((p) => p.name === "Inscripciones")
                ?.endDate.split("T")[1]
                .slice(0, 5)}
              . Durante este periodo deberás haber completado el registro para
              poder participar en el torneo. La organización se reserva el
              derecho a revisar y confirmar las inscripciones. Si no cumples los
              requisitos establecidos, no podrás participar en el torneo.
            </Warning>
            <h4>Otros datos opcionales</h4>
            <div className="row-edition-option">
              <div
                className="info-user-field"
                onClick={() => setShowClanSelector(true)}
              >
                <img src={clanImage} alt={clanName} />
                <span>{clanName}</span>
              </div>
            </div>
            {aoe2ProfileId ? (
              <button
                className="btn space-around"
                onClick={() => saveUserData()}
              >
                Guardar cambios
              </button>
            ) : (
              ""
            )}
          </div>
        </Content>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <div className="container">
        <video
          className="background-video"
          src={current_background_video}
          muted
          autoPlay
          preload="auto"
          loop
          type="video/mp4"
        ></video>
      </div>

      <Content>
        <div className="info">
          <h2>Estás inscrito!! {register_ok_title}</h2>
          <p>{register_ok_description_part_01}</p>
          <p>{register_ok_description_part_02}</p>
          <Link to={"/"}>
            <button className="btn space-around">Volver a la Home</button>
          </Link>
        </div>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .rrss {
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    margin: 0.5rem;
  }
  h4 {
    margin-top: 3rem;
  }
  .container {
    width: 100%;
    height: 88vh;
    position: absolute;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .background-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -10;
    position: absolute;
  }

  .info-user-field {
    cursor: pointer;
    width: 12rem;
    display: flex;
    align-items: center;
    margin: 1rem;
    img {
      width: 6rem;
    }
    a,
    span {
      margin-left: 0.3rem;
      font-size: 1rem;
    }
  }
  .info-user-field:hover {
    filter: blur(1px);
  }
`;

const Content = styled.div`
  width: 100%;
  height: 50vh;
  margin-top: 2vh;
  margin-bottom: 25vh;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  position: absolute;
  font-size: 1.5rem;

  .info {
    margin-left: 2rem;
    margin-right: 2rem;
    background-color: var(--black-transparency);
    padding: 2rem;
  }

  a:hover {
    color: var(--clr-grey-1);
  }

  img {
    width: 55vw;
    margin-bottom: 2rem;
  }

  .icon {
    cursor: pointer;
  }

  .register-options {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .options-center {
  }
  .options-right {
    position: absolute;
    right: 10rem;
    font-size: 1rem;
    text-decoration: underline;
    text-align: right;

    p {
      cursor: pointer;
    }
  }

  .more-help {
    font-size: 1rem;
    margin-top: 1.5rem;
    a {
      color: var(--clr-primary-light-2);
    }
    a:hover {
      color: var(--clr-primary-light-4);
    }
  }

  @media (max-width: 992px) {
    padding: 1rem;

    img {
      width: 100%;
      margin-bottom: 2rem;
    }

    .register-options {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: center;
      align-items: center;
    }

    .options-center {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-bottom: 2rem;
    }

    .options-right {
      position: inherit;
      right: 1rem;
      width: 100%;
    }
  }
`;

const ClanSelector = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .row-clan-selector {
    margin-top: 2rem;
    margin-bottom: 2rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .clan-icon {
    cursor: pointer;
    width: 6rem;
    padding: 0.2rem;
    margin: 0.2rem;
    border: 1px solid #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    span {
      margin: 0.5rem;
      height: 3rem;
      font-size: small;
    }
    img {
      max-width: 5.5rem;
      max-height: 5.5rem;
    }
  }
  .clan-icon:hover {
    background-color: var(--clr-primary-dark-1);
  }
  .clan-selected {
    background-color: var(--clr-primary-light-4);
  }
`;

const Warning = styled.div`
  background-color: crimson;
`;

export default RegisterTournamentOk;
